export const getCurrentYear = () => {
    const year = new Date().getFullYear();
    return year;
};